var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    x: 11,
    y: 5,
    fill: "currentcolor",
    rx: 1,
    transform: "rotate(90 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M8,9 C7.44771525,9 7,8.55228475 7,8 C7,7.44771525 7.44771525,7 8,7 L16.4852814,7 C17.0206728,7 17.4610816,7.42167663 17.4843375,7.95656278 L17.4843375,16.0882908 C17.5083272,16.6400542 17.0804821,17.1067944 16.5287186,17.1307841 C15.9769551,17.1547739 15.5102149,16.7269287 15.4862252,16.1751652 L15.5278149,9 L8,9 Z",
    transform: "rotate(45 12.243 12.066)"
  }))));
};
export default SvgRight;